import React from 'react';

import ZImageWrapperComponent from "./ZImageWrapperComponent";

export const EductionModuleItem = (props) => {
    const { imgName, title, content, contentPosition } = props;
    return(
        <div className="eduction-item-wrapper">
            <div className={`img ${contentPosition === "left" ? 'fl-ri': 'fl-lf'}`}>
                <img className="div-img-scale1-1 hand" src={require(`../assets/images/${imgName}`)} onClick={()=> props.clickImg()}/>
            </div>
            <div className={`content ${contentPosition === "left" ? 'fl-lf': 'fl-ri'}`}>
                <span className="fs-28">{title}</span>
                <div dangerouslySetInnerHTML={{__html: content}}></div>
            </div>
        </div>
    )
}

export default EductionModuleItem